import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { SEO_TEXTES } from '../data/seoTextes';

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-50px' },
  transition: { duration: 0.5, ease: 'easeOut' },
};

export default function CgvRdv() {
  return (
    <>
      <SEO {...SEO_TEXTES['/cgv-rdv']} path="/cgv-rdv" />
    <main data-testid="cgv-rdv-page">
      {/* Hero */}
      <section className="pt-32 pb-12">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div {...fadeUp}>
            <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#0099D6] mb-4">
              MÉTÉRIS — Rendez-vous
            </p>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-3">
              Conditions de réservation
            </h1>
            <p className="text-slate-300">
              Règles applicables aux créneaux d'accueil réservés en ligne sur meteris.fr.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Article */}
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.article
            {...fadeUp}
            className="bg-[#15171E]/80 backdrop-blur-xl border border-white/5 rounded-2xl p-6 md:p-10 space-y-8"
          >
            <p className="text-base md:text-lg text-slate-300 leading-relaxed">
              En réservant un créneau d'accueil sur meteris.fr, vous vous engagez à vous présenter
              à notre atelier (8 Rue Georges Claude, 77100 Meaux) à l'horaire choisi, ou à
              prévenir au plus tard 48 heures avant le rendez-vous en cas d'empêchement.
            </p>

            <div>
              <h2 className="text-xl md:text-2xl font-bold text-white mb-4">
                Annulation et absence
              </h2>
              <ul className="list-disc pl-6 space-y-3 text-slate-300 leading-relaxed">
                <li>
                  <strong className="text-white">Annulation au moins 48 heures à l'avance</strong>{' '}
                  : libre et sans frais, via le lien dans l'email de confirmation.
                </li>
                <li>
                  <strong className="text-white">
                    Annulation à moins de 48 heures ou absence non prévenue
                  </strong>{' '}
                  : un montant forfaitaire de{' '}
                  <strong className="text-amber-200">20 € TTC</strong> pourra être facturé au titre
                  de l'immobilisation du créneau. La facture sera émise sous 7 jours au nom et à
                  l'adresse renseignés lors de la réservation.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-bold text-white mb-4">
                Nature du créneau
              </h2>
              <p className="text-slate-300 leading-relaxed">
                Le créneau réservé est un point d'accueil d'environ 10 minutes destiné à faire le
                point sur votre besoin (particuliers, TPE/PME, professions libérales,
                collectivités). Selon le diagnostic, l'intervention peut être finalisée
                immédiatement, votre matériel conservé sur place pour traitement (quelques heures
                à quelques jours), ou une intervention planifiée à votre adresse. Le créneau ne
                constitue ni un devis ni un engagement de réalisation.
              </p>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-bold text-white mb-4">
                Données personnelles
              </h2>
              <p className="text-slate-300 leading-relaxed">
                Les informations transmises (prénom, nom, email, téléphone, motif et le cas
                échéant SIRET/raison sociale) sont utilisées uniquement pour la gestion de votre
                rendez-vous, l'envoi des rappels et, en cas d'annulation tardive, l'émission de la
                facture. Elles sont conservées pendant 36 mois maximum après le rendez-vous,
                conformément à notre{' '}
                <a
                  href="/politique-confidentialite"
                  className="text-[#0099D6] font-semibold hover:underline"
                >
                  politique de confidentialité
                </a>
                . Vous disposez d'un droit d'accès, de rectification et de suppression :{' '}
                <a
                  href="mailto:contact@meteris.fr"
                  className="text-[#0099D6] font-semibold hover:underline"
                >
                  contact@meteris.fr
                </a>
                .
              </p>
            </div>
          </motion.article>
        </div>
      </section>
    </main>
    </>
  );
}
